@if(isMF()){
<app-main-shell></app-main-shell>
}@else {
<app-msal-provider-wrapper>
    <app-main-shell></app-main-shell>
</app-msal-provider-wrapper>
}
